(() => {
  const overlay = document.getElementById('SearchOverlay');
  if (!overlay) return;

  const input = overlay.querySelector('#SearchOverlayInput');
  const results = overlay.querySelector('#SearchOverlayPredictive');
  if (!input || !results) return;

  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 200;

  let debounceTimer = null;
  let abortController = null;

  const show = () => results.removeAttribute('hidden');
  const hide = () => results.setAttribute('hidden', '');

  function setLoading(isLoading) {
    results.classList.toggle('predictive-search--loading', isLoading);
  }

  async function fetchSuggestions(term) {
    // Cancel any in-flight request
    if (abortController) abortController.abort();
    abortController = new AbortController();

    // Shopify endpoint: returns the rendered SECTION for predictive-search
    const url =
      `${window.routes?.predictive_search_url || '/search/suggest'}`
      + `?q=${encodeURIComponent(term)}`
      + `&resources[type]=product,collection,page,article,query`
      + `&resources[limit]=6`
      + `&section_id=predictive-search`;

    setLoading(true);

    const res = await fetch(url, {
      signal: abortController.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) throw new Error(`Predictive search failed: ${res.status}`);

    const html = await res.text();

    // Extract the section's inner content (Shopify wraps it in a section root)
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Dawn typically wraps section output in #shopify-section-predictive-search
    const section =
      doc.querySelector('#shopify-section-predictive-search') ||
      doc.querySelector('section') ||
      doc.body;

    // Put results inside our overlay container
    results.innerHTML = section.innerHTML;

    // If the section rendered nothing, hide
    const hasContent = results.textContent.trim().length > 0;
    if (hasContent) show();
    else hide();
  }

  function onInput() {
    const term = input.value.trim();

    if (term.length < MIN_CHARS) {
      hide();
      if (abortController) abortController.abort();
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      try {
        await fetchSuggestions(term);
      } catch (e) {
        // Abort is normal; ignore it
        if (e.name !== 'AbortError') {
          // Fail closed (no UI spam)
          hide();
          console.error(e);
        }
      } finally {
        setLoading(false);
      }
    }, DEBOUNCE_MS);
  }

  // Close dropdown when clicking outside the overlay panel
  document.addEventListener('click', (e) => {
    if (!overlay.hasAttribute('hidden')) {
      const panel = overlay.querySelector('.search-overlay__panel');
      if (panel && !panel.contains(e.target)) hide();
    }
  });

  input.addEventListener('input', onInput);

  // When overlay opens, clear old results
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-search-overlay-open]');
    if (!opener) return;
    // small delay so focus moves first
    setTimeout(() => {
      input.value = '';
      hide();
      results.innerHTML = '';
    }, 0);
  });
})();
